import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cacheByUrl = null;

    return cacheByUrl && cacheByUrl.length > 0 ? this.constructResponseFromCached(cacheByUrl, req) : next.handle(req);
  }

  private constructResponseFromCached(cacheByUrl, req: HttpRequest<any>) {
    const offset = Number(req.params.get('offset') ? req.params.get('offset') : 0);
    const perPage = Number(req.params.get('perPage') ? req.params.get('perPage') : 50);
    const content = cacheByUrl.slice(offset * perPage, (offset + 1) * perPage);

    return of(
      new HttpResponse({
        body: {
          offset,
          perPage,
          order: 'DESC',
          total: cacheByUrl.length,
          content,
        },
        status: 200,
      })
    );
  }
}
